var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'row',
    _vm.gutter ? ("q-col-gutter-" + _vm.gutter) : '',
    { reverse: _vm.reverse },
    { 'justify-start': _vm.justifyStart },
    { 'justify-center': _vm.justifyCenter },
    { 'justify-end': _vm.justifyEnd },
    { 'justify-around': _vm.justifyAround },
    { 'justify-between': _vm.justifyBetween },
    { 'items-center': _vm.itemsCenter },
    { 'items-end': _vm.itemsEnd } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }